module.exports = "<div class=\"$handle keyframe-property\" data-name=\"{{keyframeProperty.name}}\" >&nbsp;</div>\n"